import { createApiClient, apiClient } from './apiClient';

// ─── Types ────────────────────────────────────────────────────────────────────

export interface DayData {
	day: number;
	dayShortName: string;
	dayName: string;
	date: string; // ISO "YYYY-MM-DD"
	reportDay?: number;
	weekOffset?: number;
	periodOffset?: number;
	quarterOffset?: number;
	yearOffset?: number;
	dayOffset?: number;
}

export interface CurrentFiscalContext {
	year: number;
	period: number;
	week: number;
	weekInYear: number;
	date: string;
	quarter: number;
}

export interface WeekData {
	week: number;
	weekInYear: number;
	days?: DayData[];
}

export interface PeriodData {
	period: number;
	weeks: WeekData[];
}

export interface YearData {
	year: number;
	periods: PeriodData[];
}

export interface PeriodWeekResponse {
	currentFiscalContext?: CurrentFiscalContext;
	data: YearData[];
}

// ─── Service Function ─────────────────────────────────────────────────────────

/**
 * Fetch period-week data for the given years (and optionally specific periods).
 *
 * Calls: GET /api/period-weeks?year=2025,2026&period=1,2
 *
 * @param years  - Array of year numbers (e.g. [2025, 2026])
 * @param periods - Optional array of period numbers to filter (e.g. [1, 2])
 * @returns Typed PeriodWeekResponse
 */
export async function fetchPeriodWeeks(
	years: number[],
	periods?: number[]
): Promise<PeriodWeekResponse> {
	const api = createApiClient();
    const clientTimestamp = new Date().toISOString();
	// Build query string with comma-separated values
	const params: Record<string, string> = {
		year: years.join(','),
		clientTimestamp: encodeURIComponent(clientTimestamp)

	};

	if (periods && periods.length > 0) {
		params.period = periods.join(',');
	}

	const queryString = new URLSearchParams(params).toString();
	const endpoint = `/period-weeks?${queryString}`;

	const response = await apiClient(api, endpoint, 'GET');
	return response as PeriodWeekResponse;
}
